import { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, Link as MuiLink, CircularProgress, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, forgotPassword } from '../../actions/userAction';
import MetaData from '../Layouts/MetaData';
import AuthLayout from './AuthLayout';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const { error, message, loading } = useSelector((state) => state.forgotPassword);
    const [email, setEmail] = useState("");
  
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.set('email', email);
        dispatch(forgotPassword(formData));
        setEmail("");
    };

      useEffect(() => {
          if (error) {
              console.error(error);
              dispatch(clearErrors());
          }
      }, [dispatch, error, message]);
  
      return (
          <AuthLayout
              sidebarTitle="Forgot Password"
              sidebarTagline="Enter the email address associated with your account"
          >
              <MetaData title="Forgot Password - AmritLok" />
              <Typography component="h2" variant="h5" sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}>
                  Forgot Password
              </Typography>
              <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                  {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
                  {message && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{message}</Alert>}
                  <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                  />
                  <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2, py: 1.5 }}
                      disabled={loading}
                  >
                      {loading ? <CircularProgress size={24} /> : 'Submit'}
                  </Button>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <MuiLink component={Link} to="/login" variant="body2">
                          Remember your password? Login
                      </MuiLink>
                  </Box>
                  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <MuiLink component={Link} to="/register" variant="body2">
                          New? Create an account
                      </MuiLink>
                  </Box>
              </Box>
          </AuthLayout>
      );
  };
  
  export default ForgotPassword;